import { createFetchEntityAction } from '../generic/entityAction';

export const FOOD_PRIVILEGE_ENROLLMENT_LIST = 'FOOD_PRIVILEGE_ENROLLMENT_LIST';

export default {
    fetchByEnrollmentId: createFetchEntityAction(enrollmentId => `/api/enrollment/${enrollmentId}/food-privileges`, FOOD_PRIVILEGE_ENROLLMENT_LIST),
};